export default "__VITE_ASSET__Beo6ampv__"